module.exports = __webpack_public_path__ + "img/wolph.32b121ac.png";